import { categories, categoryImages } from '@/utils/constants';

export default function CategoryGrid() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            Sugargoo Spreadsheet Product Categories
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            Browse our organized product categories to discover trending items across Shoes, Hoodies, T-Shirts, Jackets, Accessories, and more on Sugargoo Spreadsheet.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group relative overflow-hidden rounded-lg bg-background-100 cursor-pointer transition-all duration-300 hover:scale-[1.02]"
            >
              <div className="relative w-full h-40 md:h-48 overflow-hidden">
                <img
                  src={categoryImages[cat.name]}
                  alt={`${cat.name} - Sugargoo Spreadsheet Category`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-3 md:p-4">
                <h3 className="text-sm md:text-base font-semibold text-background-50 whitespace-nowrap">
                  {cat.name}
                </h3>
                <div className="flex items-center gap-1 mt-1">
                  <span className="text-xs text-background-50/70">View Products</span>
                  <span className="w-3 h-3 flex items-center justify-center">
                    <i className="ri-arrow-right-up-line text-xs text-background-50/70"></i>
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}